import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4e74a2",
      light: "#b2c4da",
    },
    secondary: {
      main: "#7153a0",
      light: "#c3b5d9",
    },
    error: {
      main: "#b55374",
      light: "#e2bdca",
    },
    warning: {
      main: "#b79214",
      light: "#f0d67e",
    },
    info: {
      main: "#dc7d0e",
      light: "#f7c890",
    },
    success: {
      main: "#7c9163",
      light: "#c8d2bd",
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        elevation8: {
          boxShadow: "0px 5px 5px -3px rgb(78 116 162 / 20%), 0px 8px 10px 1px rgb(78 116 162 / 14%), 0px 3px 14px 2px rgb(78 116 162 / 12%)",
        },
      },
    },
  },
});

export default theme;